<template>
  <d-modal
    :key="'popup-visits-form-patient-' + isVisible"
    :class="{ 'showModalPatientInfo': true, 'is-hidden': !isVisible }"
    style="background-color: rgba(0,0,0,0.8)!important;">
    <button
      @click.prevent.stop="onClosePopup"
      class="mr-1 new-close-button">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header class="showModalPatientInfo__header">
      <d-modal-title class="showModalPatientInfo__header_title">
        Karta pacjenta
        <span class="showModalPatientInfo__header_subtitle">{{data.name}} {{data.last_name}}</span>
        <div class="showModalPatientInfo__header_group">
          <div class="form-group-flex">
            <label style="font-weight: 600">
              <i class="material-icons">phone</i> Telefon:
            </label>
            <p class="simpleText">
              {{data.phone}}
            </p>
          </div>
          <div class="form-group-flex">
            <label style="font-weight: 600; margin-left: 2rem">
              <i class="material-icons">email</i>  Email:
            </label>
            <p class="simpleText">
              {{data.email ? data.email : 'Brak'}}
            </p>
          </div>
        </div>
        <div class="showModalPatientInfo__header_statistics">
          <div class="form-group-flex">
            <label style="font-weight: 600">
              <i class="material-icons">alarm_on</i> Liczba wizyt:
            </label>
            <p class="simpleText">
              {{data.count_visits}}
            </p>
          </div>
          <div class="form-group-flex">
            <label style="font-weight: 600; margin-left: 3.5rem;">
              <i class="material-icons">alarm_off</i>  Anulowane wizyty:
            </label>
            <p class="statisticsTextCancel">
              {{data.count_cancelled_visits + ' '}}
              <span
                :class="{
                'promising': cancelledVisitsPercent <= 10,
                'attention': cancelledVisitsPercent <= 20,
                'danger': cancelledVisitsPercent > 20
                }">
                ({{ cancelledVisitsPercent }} %)
              </span>
            </p>
          </div>
        </div>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="showModalPatientInfo__body">
      <d-row>
        <d-col cols="12" md="6" lg="4">
          <div class="showModalPatientInfo__body_group">
            <h3 class="showModalPatientInfo__body_group_head"><i class="material-icons">person</i> Adres</h3>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                Ulica:
              </label>
              <p class="simpleText">
                {{data.street ? data.street : 'Brak'}}
              </p>
            </div>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                Numer domu:
              </label>
              <p class="simpleText">
                {{data.number_home}} {{data.number_local ? ('/ ' + data.number_local) : 'Brak'}}
              </p>
            </div>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                Miasto:
              </label>
              <p class="simpleText">
                {{data.post_code}} {{data.city ? data.city : 'Brak'}}
              </p>
            </div>
          </div>
        </d-col>
        <d-col cols="12" md="6" lg="4">
          <div class="showModalPatientInfo__body_group">
            <h3 class="showModalPatientInfo__body_group_head"><i class="material-icons">credit_card</i> Dodatkowe dane</h3>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                PESEL:
              </label>
              <p class="simpleText">
                {{data.pesel}}
              </p>
            </div>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                Data urodzenia:
              </label>
              <p class="simpleText">
                {{data.birthday_date ? data.birthday_date : 'Brak'}}
              </p>
            </div>
            <div class="showModalPatientInfo__body_group_box">
              <label>
                Płeć:
              </label>
              <p class="simpleText">
                {{data.sex === 'MALE' ? 'Mężczyzna' : 'Kobieta'}}
              </p>
            </div>
          </div>
        </d-col>
        <d-col cols="12" md="6" lg="4">
          <div class="showModalPatientInfo__body_group">
            <h3 class="showModalPatientInfo__body_group_head"><i class="material-icons">record_voice_over</i> Zgody</h3>
            <div class="showModalPatientInfo__body_group_box approval">
              <label class="special_label">
                Uzyskiwanie informacji o zdrowiu i świadczeniach: <span :style="data.health_benefits_inf === '1' ? 'color: #17c671' : 'color: #c4183c'">{{ data.health_benefits_inf === '1' ? 'Tak' : 'Nie' }}</span>
              </label>
              <label class="special_label">
                Uzyskiwanie dokumentacji medycznej: <span :style="data.medical_records === '1' ? 'color: #17c671' : 'color: #c4183c'">{{ data.medical_records === '1' ? 'Tak' : 'Nie'}}</span>
              </label>
            </div>
          </div>
        </d-col>
      </d-row>
      <d-form>
        <d-card class="mb-5">
          <d-tabs
            ref="visits-form-patient-tabs"
            card>
            <!-- Historia Wizyt -->
            <d-tab title="Historia Wizyt">
              <patients-form-visits
                v-if="allDataLoaded"
                ref="patients-form-visits"
                :all-institutions="allInstitutions"
                :all-users="allUsers"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 0"
                :patient="data" />
            </d-tab>
            <!-- Dane opiekunów -->
            <d-tab title="Dane opiekunów">
              <patients-form-guardians
                v-if="allDataLoaded"
                ref="patients-form-guardians"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 1"
                :patient="data" />
            </d-tab>
            <!-- E-Dokumenty -->
            <d-tab title="E-Dokumenty">
              <patients-form-documents
                v-if="allDataLoaded"
                ref="patients-form-documents"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 2"
                :patient="data"
                :visit-id="visitId" />
            </d-tab>
            <!-- Badania -->
            <d-tab title="Badania">
              <patients-form-medical
                v-if="allDataLoaded"
                ref="patients-form-medical"
                :is-add-medical-enabled="!!visitForm"
                :is-in-popup="true"
                :all-institutions="allInstitutions"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 3"
                :patient="data"
                :visit-id="visitId" />
            </d-tab>
            <!-- Wyniki diagnozy -->
            <d-tab title="Wyniki diagnozy">
              <patients-form-diagnosis
                v-if="allDataLoaded"
                ref="patients-form-diagnosis"
                :all-users="allUsers"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 4"
                :patient="data" />
            </d-tab>
            <!-- Informacje -->
            <d-tab title="Informacje">
              <patients-form-information
                v-if="allDataLoaded"
                ref="patients-form-information"
                :all-users="allUsers"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 5"
                :patient="data" />
            </d-tab>
            <!-- Opinie -->
            <d-tab title="Opinie">
              <patients-form-opinions
                v-if="allDataLoaded"
                ref="patients-form-opinions"
                :is-in-popup="true"
                :all-institutions="allInstitutions"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 6"
                :patient="data" />
            </d-tab>
            <!-- Orzeczenia -->
            <d-tab title="Orzeczenia">
              <patients-form-decisions
                v-if="allDataLoaded"
                ref="patients-form-decisions"
                :all-institutions="allInstitutions"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 7"
                :patient="data" />
            </d-tab>
            <!-- Upoważnienia -->
            <d-tab title="Upoważnienia">
              <patients-form-auth
                v-if="allDataLoaded"
                ref="patients-form-auth"
                :is-in-popup="true"
                :is-visible="allDataLoaded && $refs['visits-form-patient-tabs'].currentTab === 8"
                :patient="data" />
            </d-tab>
          </d-tabs>
        </d-card>
      </d-form>
      <div class="form-group-flex mt-5">
        <d-button
          theme="danger"
          @click.prevent.stop="onClosePopup"
          class="mr-1 close-visit-patient-button">
          <i class="material-icons">arrow_back</i>
          Zamknij podgląd
        </d-button>
      </div>
      <div
        v-if="!allDataLoaded"
        class="pb-3 pt-3 text-center overlay-loading">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import PatientsFormVisits from '@/components/forms/patients/PatientsFormVisits.vue';
import PatientsFormGuardians from '@/components/forms/patients/PatientsFormGuardians.vue';
import PatientsFormDocuments from '@/components/forms/patients/PatientsFormDocuments.vue';
import PatientsFormMedical from '@/components/forms/patients/PatientsFormMedical.vue';
import PatientsFormDiagnosis from '@/components/forms/patients/PatientsFormDiagnosis.vue';
import PatientsFormInformation from '@/components/forms/patients/PatientsFormInformation.vue';
import PatientsFormOpinions from '@/components/forms/patients/PatientsFormOpinions.vue';
import PatientsFormDecisions from '@/components/forms/patients/PatientsFormDecisions.vue';
import PatientsFormAuth from '@/components/forms/patients/PatientsFormAuth.vue';

export default {
  name: 'visits-form-patient-popup',
  components: {
    'patients-form-visits': PatientsFormVisits,
    'patients-form-guardians': PatientsFormGuardians,
    'patients-form-documents': PatientsFormDocuments,
    'patients-form-medical': PatientsFormMedical,
    'patients-form-diagnosis': PatientsFormDiagnosis,
    'patients-form-information': PatientsFormInformation,
    'patients-form-opinions': PatientsFormOpinions,
    'patients-form-decisions': PatientsFormDecisions,
    'patients-form-auth': PatientsFormAuth
  },
  props: {
    isVisible: {
      default: false,
      type: Boolean
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    visitForm: {
      type: Boolean
    },
    visitId: {
      required: false,
      type: Number
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.allInstitutionsLoaded && this.allUsersLoaded;
    },
    cancelledVisitsPercent () {
      let percent = 0;
      if (this.data.count_cancelled_visits) {
        percent = (this.data.count_cancelled_visits / this.data.count_visits) * 100;
      }

      return percent.toFixed();
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue) {
        this.loadPatientData();

        if (!this.allInstitutionsLoaded || !this.allUsersLoaded) {
          this.loadAdditionalData();
        }
      }
    }
  },
  data () {
    return {
      data: {
        id: '',
        birthday_date: '',
        city: '',
        count_cancelled_visits: 0,
        count_visits: 0,
        email: '',
        identification: null,
        institution_id: '',
        last_name: '',
        name: '',
        nfz: null,
        nip: null,
        number_home: '',
        number_local: '',
        patient_number: '',
        pesel: '',
        phone: '',
        place_of_birth: '',
        post_code: '',
        previous_id: '',
        school_city: '',
        school_class: '',
        school_name: '',
        school_postcode: '',
        school_street: '',
        school_street_local_number: '',
        school_street_number: '',
        school_type: '',
        sex: '',
        street: '',
        visits_history: []
      },
      allInstitutions: [],
      allInstitutionsLoaded: false,
      allUsers: [],
      allUsersLoaded: false,
      loaded: false,
      loadError: false
    }
  },
  mounted () {
    if (this.isVisible) {
      this.loadPatientData();
      this.loadAdditionalData();
    }
  },
  methods: {
    loadPatientData () {
      Vue.set(this, 'loaded', false);
      FormUtils.loadItemData(this, {
        id: this.patientId,
        endpointBase: '/patients/item/',
        instanceFields: [
          'id',
          'birthday_date',
          'city',
          'count_cancelled_visits',
          'count_visits',
          'email',
          'identification',
          'institution_id',
          'last_name',
          'name',
          'nfz',
          'nip',
          'number_home',
          'number_local',
          'patient_number',
          'pesel',
          'phone',
          'place_of_birth',
          'post_code',
          'previous_id',
          'school_city',
          'school_class',
          'school_name',
          'school_postcode',
          'school_street',
          'school_street_local_number',
          'school_street_number',
          'school_type',
          'sex',
          'street',
          'visits_history'
        ],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items?ignore_users_filters=1',
        outputKey: 'allInstitutions',
        loadedKey: 'allInstitutionsLoaded',
        params: {
          pagination: false
        },
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items?ignore_users_filters=1',
        outputKey: 'allUsers',
        loadedKey: 'allUsersLoaded',
        params: {
          pagination: false,
        }
      });
    },
  }
}
</script>

<style lang="scss">
  .close {
    display: none !important;
  }
  .showModalPatientInfo {
     &.is-hidden {
      display: none!important;
      pointer-events: none!important;
    }
    .patients-form-decisions {
      .modal-dialog {
        margin-left: 20% !important;
      }
    }
    &__body {
      &_group {
        &_head {
          @media only screen and (max-width: 1370px) {
            font-size: 1.3rem !important;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
